const _ = require('./enum');
module.exports = {
  [_.NO_PREFERENCE]: { id: _.NO_PREFERENCE, label: 'No preference' },
  [_.CHALLENGE_MANDATORY]: { id: _.CHALLENGE_MANDATORY, label: 'Challenge mandatory' },
  [_.CHALLENGE_REQUESTED]: { id: _.CHALLENGE_REQUESTED, label: 'Challenge requested' },
  [_.NO_CHALLENGE]: { id: _.NO_CHALLENGE, label: 'No challenge' },
};
